import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../../util/utils';
import {IconoirMagicWand} from '@ey-xd/motif-icon';

import Module from '..';

const ProjectWizardModule = ({onClick}) => {
	const props = {
		icon: IconoirMagicWand,
		label: labels.projectWizard,
		onClick
	};

	return <Module {...props} />;
};

ProjectWizardModule.propTypes = {};

ProjectWizardModule.defaultProps = {};

export default ProjectWizardModule;
